import { DashboardView } from '@/widgets/DashboardView'

export const DashboardPage = () => <DashboardView />
